import {Component, Input, OnInit} from '@angular/core';
import {TarefaService} from "../../../services/tarefa-service";
import {ToastrService} from "ngx-toastr";
import {ItemHora, TarefasAgrupadasPorHora} from "../../../models/tarefas-agrupadas-por-hora";
import {ItemTarefa} from "../../../models/lista-tarefa";

@Component({
    selector: 'app-semanal',
    templateUrl: './semanal.component.html',
    styleUrl: './semanal.component.css',
    standalone: false
})
export class SemanalComponent implements OnInit {
  @Input() telaPequena = false
  events: { title: string, start: string, end: string }[] = [];
  loading = false;
  semana: { nome: string, data: Date }[] = [];
  currentTimeTop = 0;
  horas: string[] = [];
  lista = new TarefasAgrupadasPorHora();
  diaSelecionado: Date = new Date(); // por padrão hoje

  ngOnInit() {
    this.horas = [];
    for (let i = 6; i < 23; i++) {
      this.horas.push(`${i.toString().padStart(2, '0')}:00`);
    }
    this.definirSemana(new Date());
    this.atualizarLinhaTempo();

    setInterval(() => {
      this.atualizarLinhaTempo();
    }, 60000);
  }

  selecionarDia(data: Date) {
    this.diaSelecionado = data;
    this.buscarCompromissosDiario(data);
  }

  ehSelecionado(data: Date): boolean {
    return this.diaSelecionado.toDateString() === data.toDateString();
  }

  getEventStyle(event: { start: string, end: string }) {
    const startMin = this.timeToMinutes(event.start);
    const endMin = this.timeToMinutes(event.end);
    const baseMin = 6 * 60; // início da timeline: 6h da manhã

    return {
      top: `${startMin - baseMin}px`,
      height: `${endMin - startMin}px`
    };
  }

  timeToMinutes(time: string): number {
    const [h, m] = time.split(':').map(Number);
    return h * 60 + m;
  }


  atualizarLinhaTempo() {
    const agora = new Date();
    const minutosAgora = agora.getHours() * 60 + agora.getMinutes();
    const minutosBase = 6 * 60; // timeline começa às 06:00
    this.currentTimeTop = minutosAgora - minutosBase;
  }

  definirSemana(dataReferencia: Date) {
    const diaSemana = dataReferencia.getDay(); // 0 = domingo
    const segunda = new Date(dataReferencia);
    segunda.setDate(dataReferencia.getDate() - (diaSemana === 0 ? 6 : diaSemana - 1));

    this.semana = [];
    for (let i = 0; i < 5; i++) {
      const dia = new Date(segunda);
      dia.setDate(segunda.getDate() + i);
      this.semana.push({
        nome: this.primeiraLetraMaiuscula(dia.toLocaleDateString('pt-BR', { weekday: 'short' })),
        data: dia
      });
    }
  }

  private primeiraLetraMaiuscula(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  semanaAnterior() {
    const anterior = new Date(this.semana[0].data);
    anterior.setDate(anterior.getDate() - 7);
    this.definirSemana(anterior);
  }

  proximaSemana() {
    const proxima = new Date(this.semana[0].data);
    proxima.setDate(proxima.getDate() + 7);
    this.definirSemana(proxima);
  }

  voltarHoje() {
    const hoje = new Date();
    this.definirSemana(hoje);
    this.selecionarDia(hoje);
  }

  ehHoje(data: Date): boolean {
    const hoje = new Date();
    return data.toDateString() === hoje.toDateString();
  }

  constructor(private tarefaServico: TarefaService,
              private toastr: ToastrService) {
    this.buscarCompromissosDiario(new Date());

  }

  carregarTarefas(tarefasAgrupadas: TarefasAgrupadasPorHora) {
    this.events = [];

    tarefasAgrupadas.itemHoras.forEach((item: ItemHora) => {
      item.tarefas.forEach((tarefa: ItemTarefa) => {
        const dataInicio = new Date(tarefa.dataInicial);
        let dataFim = tarefa.dataPrevisaoFinalizacao
          ? new Date(tarefa.dataPrevisaoFinalizacao)
          : new Date(dataInicio.getTime() + 30 * 60000); // +30 min se não tiver previsão

        // Se for a mesma hora, adiciona 30 minutos
        if (dataInicio.getTime() === dataFim.getTime()) {
          dataFim = new Date(dataInicio.getTime() + 30 * 60000);
        }

        this.events.push({
          title: tarefa.descricao,
          start: this.formatTime(dataInicio),
          end: this.formatTime(dataFim)
        });
      });
    });
  }

  formatTime(date: Date): string {
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  buscarCompromissosDiario(dataSemana: Date) {
    const hoje = dataSemana.toISOString().split('T')[0];
    this.tarefaServico.buscarCompromissosDiarioAgrupadoPorHora(hoje).subscribe(resultado => {
      if (resultado.sucesso) {
        this.lista = resultado.dados;
        this.carregarTarefas(this.lista); // <-- Adicione isso aqui
      }
      this.loading = false;
    }, error => {
      this.toastr.error('Erro ao carregar compromissos');
      this.loading = false;
    });
  }
}
